// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e970644","667":"66961b07","977":"d9755705"}[chunkId] + ".chunk.js";
};